import { Link } from 'react-router-dom';

export function HomePage() {
  return (
    <main className="page">
      <h1>Mat Monitor</h1>
      <p>Head-table controls and mat screens for Elite Wrestling Productions.</p>
      <p>
        <Link to="/admin">Admin</Link>
      </p>
    </main>
  );
}
